module.exports = __webpack_public_path__ + "img/logo-uplus.703adc4.svg";